import React from 'react';

export default ({ style, locale }) => (
  <p style={{ ...style, fontSize: '10px', color: '#949494' }}>
    {locale.common.consent}
  </p>
);
